import Entity from '../entity'

export default class Wallet extends Entity<number>{
    balance: string  = null;
    userId: string  = null;
    userNo: string  = null;
    tenantId: number  = null;
    creationTime: string;
    remark: string  = null;

}